"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = {
    key: 0,
    class: "compose-overlay eh-popup-overlay"
};
var _hoisted_2 = { class: "field-row" };
var _hoisted_3 = { class: "field-value from-value" };
var _hoisted_4 = { class: "provider-name" };
var _hoisted_5 = {
    key: 0,
    class: "provider-email"
};
var _hoisted_6 = { class: "field-row" };
var _hoisted_7 = { class: "field-value to-value" };
var _hoisted_8 = { class: "recipient-chip" };
var _hoisted_9 = { class: "recipient-email" };
var _hoisted_10 = { class: "field-row" };
var _hoisted_11 = { class: "editor-container" };
var _hoisted_12 = { class: "editor-toolbar" };
var _hoisted_13 = ["title", "onClick"];
var _hoisted_14 = {
    key: 0,
    class: "if-attachment-exist"
};
var _hoisted_15 = {
    key: 1,
    class: "icon"
};
var _hoisted_16 = { class: "file-name" };
var _hoisted_17 = { class: "modal-footer" };
var _hoisted_18 = { class: "footer-right" };
var _hoisted_19 = ["disabled"];
var _hoisted_20 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning"
};
var _hoisted_21 = {
    key: 1,
    class: "glyphicon glyphicon-send"
};
var vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'EmailComposeModal',
    props: {
        show: { type: Boolean },
        nurse: {},
        provider: {}
    },
    emits: ["close", "sent"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var modalRef = (0, vue_3.ref)(null);
        var editorRef = (0, vue_3.ref)(null);
        var fileInput = (0, vue_3.ref)(null); //added this for enchanced functionalty 
        var attachedFile = (0, vue_3.ref)(null); //add this for enhanced functionaity
        var subject = (0, vue_3.ref)('');
        var body = (0, vue_3.ref)('');
        var isSending = (0, vue_3.ref)(false);
        var position = (0, vue_3.reactive)({ x: 100, y: 100 });
        var dragOffset = (0, vue_3.reactive)({ x: 0, y: 0 });
        var isDragging = (0, vue_3.ref)(false);
        var activeFormats = (0, vue_3.reactive)({
            bold: false,
            italic: false,
            underline: false
        });
        var toolbarButtons = [
            { action: 'bold', icon: 'bi-type-bold', title: 'Bold (Ctrl+B)' },
            { action: 'italic', icon: 'bi bi-type-italic glyphicon-italic', title: 'Italic (Ctrl+I)' },
            { action: 'underline', icon: 'bi bi-type-underline glyphicon-text-color', title: 'Underline (Ctrl+U)' }
        ];
        // Center modal on open
        (0, vue_3.watch)(function () { return props.show; }, function (show) {
            if (show && typeof window !== 'undefined') {
                position.x = Math.max(50, (window.innerWidth - 600) / 2);
                position.y = Math.max(50, (window.innerHeight - 500) / 2);
                subject.value = '';
                if (editorRef.value) {
                    editorRef.value.innerHTML = '';
                }
            }
        });
        function startDrag(e) {
            isDragging.value = true;
            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            dragOffset.x = clientX - position.x;
            dragOffset.y = clientY - position.y;
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('mouseup', stopDrag);
            document.addEventListener('touchmove', onDrag);
            document.addEventListener('touchend', stopDrag);
        }
        function onDrag(e) {
            if (!isDragging.value)
                return;
            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            position.x = Math.max(0, Math.min(clientX - dragOffset.x, window.innerWidth - 400));
            position.y = Math.max(0, Math.min(clientY - dragOffset.y, window.innerHeight - 100));
        }
        function stopDrag() {
            isDragging.value = false;
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
        }
        function applyFormat(command) {
            var _a;
            document.execCommand(command, false);
            (_a = editorRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            updateActiveFormats();
        }
        function updateActiveFormats() {
            activeFormats.bold = document.queryCommandState('bold');
            activeFormats.italic = document.queryCommandState('italic');
            activeFormats.underline = document.queryCommandState('underline');
        }
        function insertLink() {
            var _a;
            var url = prompt('Enter URL:');
            if (url) {
                document.execCommand('createLink', false, url);
                (_a = editorRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
        // Function to trigger the file input
        function triggerFileInput() {
            var _a;
            (_a = fileInput.value) === null || _a === void 0 ? void 0 : _a.click();
        }
        function handleInput() {
            if (editorRef.value) {
                body.value = editorRef.value.innerHTML;
            }
        }
        // Handle file change when a file is selected
        function handleFileChange(event) {
            var target = event.target;
            if (target.files && target.files.length > 0) {
                attachedFile.value = target.files[0]; // Store the selected file
                console.log(attachedFile.value);
            }
        }
        function handleClose() {
            var _a, _b;
            var hasContent = subject.value.trim() || ((_b = (_a = editorRef.value) === null || _a === void 0 ? void 0 : _a.innerText) === null || _b === void 0 ? void 0 : _b.trim());
            if (hasContent) {
                if (!confirm('Discard this email?'))
                    return;
            }
            emit('close');
        }
        function handleSend() {
            return __awaiter(this, void 0, void 0, function () {
                var formData;
                var _a, _b;
                return __generator(this, function (_c) {
                    if (!((_a = props.nurse) === null || _a === void 0 ? void 0 : _a.email) || !subject.value.trim()) {
                        alert('Please enter a subject');
                        return [2 /*return*/];
                    }
                    isSending.value = true;
                    formData = new FormData();
                    formData.append('API_Meth', "SendPatientEmail");
                    formData.append('to', props.nurse.email);
                    formData.append('subject', subject.value);
                    formData.append('body', ((_b = editorRef.value) === null || _b === void 0 ? void 0 : _b.innerHTML) || '');
                    formData.append("patientName", props.nurse.firstName + " " + props.nurse.lastName);
                    formData.append("providerName", props.provider.name);
                    formData.append("fromEmail", props.provider.email);
                    formData.append("accountnumber", props.nurse.accountnumber);
                    // If there's an attached file, append it to the FormData
                    if (attachedFile.value) {
                        formData.append('file', attachedFile.value);
                    }
                    // Simulate API call
                    //await new Promise(resolve => setTimeout(resolve, 1500))
                    /*emit('sent', {
                      to: props.patient.email,
                      subject: subject.value,
                      body: editorRef.value?.innerHTML || ''
                    })
                    */
                    emit('sent', formData);
                    isSending.value = false;
                    emit('close');
                    return [2 /*return*/];
                });
            });
        }
        (0, vue_3.onUnmounted)(function () {
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                    default: (0, vue_2.withCtx)(function () {
                        var _a, _b, _c, _d;
                        return [
                            (_ctx.show)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                                    (0, vue_2.createElementVNode)("div", {
                                        ref_key: "modalRef",
                                        ref: modalRef,
                                        class: "compose-modal eh-popup-panel",
                                        style: (0, vue_2.normalizeStyle)({ left: position.x + 'px', top: position.y + 'px' })
                                    }, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "modal-header",
                                            onMousedown: startDrag,
                                            onTouchstart: startDrag
                                        }, [
                                            _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("div", { class: "header-left" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope bi-envelope" }),
                                                (0, vue_2.createElementVNode)("h3", null, "New Email")
                                            ], -1)),
                                            (0, vue_2.createElementVNode)("div", { class: "header-actions" }, [
                                                _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("button", {
                                                    class: "header-btn minimize",
                                                    title: "Minimize"
                                                }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-minus bi-dash-lg" })
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "header-btn close",
                                                    title: "Close",
                                                    onClick: handleClose
                                                }, __spreadArray([], (_cache[2] || (_cache[2] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1)
                                                ])), true))
                                            ])
                                        ], 32),
                                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                            _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("label", null, "From:", -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.provider.name), 1),
                                                (_ctx.provider.email)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_5, "<" + (0, vue_2.toDisplayString)(_ctx.provider.email) + ">", 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                            _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("label", null, "To:", -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_8, [
                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((_a = _ctx.nurse) === null || _a === void 0 ? void 0 : _a.firstName) + " " + (0, vue_2.toDisplayString)((_b = _ctx.nurse) === null || _b === void 0 ? void 0 : _b.lastName) + " ", 1),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_9, "<" + (0, vue_2.toDisplayString)((_c = _ctx.nurse) === null || _c === void 0 ? void 0 : _c.email) + ">", 1)
                                                ])
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                            _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("label", null, "Subject:", -1)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((subject).value = $event); }),
                                                type: "text",
                                                class: "subject-input",
                                                placeholder: "Enter subject..."
                                            }, null, 512), [
                                                [vue_2.vModelText, subject.value]
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                                ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(toolbarButtons, function (btn) {
                                                    return (0, vue_2.createElementVNode)("button", {
                                                        key: btn.action,
                                                        title: btn.title,
                                                        class: (0, vue_2.normalizeClass)({ active: activeFormats[btn.action] }),
                                                        onClick: function ($event) { return (applyFormat(btn.action)); }
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", {
                                                            class: (0, vue_2.normalizeClass)(["glyphicon", btn.icon])
                                                        }, null, 2)
                                                    ], 10, _hoisted_13);
                                                }), 64)),
                                                _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("div", { class: "toolbar-divider" }, null, -1)),
                                                (0, vue_2.createElementVNode)("button", {
                                                    title: "Insert Link",
                                                    onClick: insertLink
                                                }, __spreadArray([], (_cache[8] || (_cache[8] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-link bi-link" }, null, -1)
                                                ])), true)),
                                                (0, vue_2.createElementVNode)("input", {
                                                    type: "file",
                                                    ref_key: "fileInput",
                                                    ref: fileInput,
                                                    style: { "display": "none" },
                                                    onChange: handleFileChange
                                                }, null, 544),
                                                (0, vue_2.createElementVNode)("button", {
                                                    title: "Attach File",
                                                    onClick: triggerFileInput
                                                }, __spreadArray([], (_cache[9] || (_cache[9] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-paperclip bi-paperclip" }, null, -1)
                                                ])), true))
                                            ]),
                                            (attachedFile.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                                                    (attachedFile.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                            key: 0,
                                                            class: "btn-attachment",
                                                            onClick: _cache[1] || (_cache[1] = function ($event) { return (attachedFile.value = null); })
                                                        }, __spreadArray([], (_cache[11] || (_cache[11] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-trash" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" Remove ", -1)
                                                        ])), true)))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (attachedFile.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_15, __spreadArray([], (_cache[12] || (_cache[12] = [
                                                            (0, vue_2.createElementVNode)("i", { class: "bi bi-paperclip" }, "Attachment:", -1)
                                                        ])), true)))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)((_d = attachedFile.value) === null || _d === void 0 ? void 0 : _d.name), 1)
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (0, vue_2.createElementVNode)("div", {
                                                ref_key: "editorRef",
                                                ref: editorRef,
                                                class: "editor-content",
                                                contenteditable: "true",
                                                onInput: handleInput,
                                                onKeyup: updateActiveFormats,
                                                onMouseup: updateActiveFormats
                                            }, null, 544)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                            _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("div", { class: "footer-left" }, null, -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-discard",
                                                    onClick: handleClose
                                                }, __spreadArray([], (_cache[13] || (_cache[13] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" Discard ", -1)
                                                ])), true)),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-send",
                                                    onClick: handleSend,
                                                    disabled: isSending.value
                                                }, [
                                                    (isSending.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_20))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_21)),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isSending.value ? 'Sending...' : 'Send Email'), 1)
                                                ], 8, _hoisted_19)
                                            ])
                                        ])
                                    ], 4)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ];
                    }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
